import './css/app.css';
import 'vendor/lazysizes';
import { App } from '@grafikr/components';

import components from 'framework/components';
import state from 'framework/state';

const app = new App();

components(app);
state(app);
app.mount();

document.addEventListener('shopify:section:load', app.mount);
